import scrollCtrlLenis from './scrollCtrlLenis'
import scrollCtrlNative from './scrollCtrlNative'

function scrollCtrl(){

  const scrollType = window.scrollType// virtual || smooth || native

  if (window.isComplexe && scrollType === 'lenis') {
    scrollCtrlLenis()
  } else {
    scrollCtrlNative()
  }

}
export default scrollCtrl